module.exports = __webpack_public_path__ + "static/img/stargroup.c2d611a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/stargroup.png
// module id = OzjB
// module chunks = 1